import { EProjectSection, trackEventV2 } from '../trackEventV2';
import { EGroupBookingEventName, IGroupBookingRequestSubmittedEvent } from './types';

export const trackGroupBookingRequestSubmittedEvent = (
  event: IGroupBookingRequestSubmittedEvent,
) => {
  trackEventV2(
    EGroupBookingEventName.GROUP_BOOKING_REQUEST_SUBMITTED,
    EProjectSection.MARKETPLACE,
    {
      ...event,
    },
  );
};
